import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import TaxPayer from "../../models/tax-payer";
import TaxPayerFixedLimitsForm from "./TaxPayerFixedLimitsForm";

interface TaxPayerFixedLimitsModalProps {
  show: boolean;
  taxPayer?: TaxPayer;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const TaxPayerFixedLimitsModal: React.FC<TaxPayerFixedLimitsModalProps> = ({
  show,
  taxPayer,
  onCancel,
  onSuccess,
}) => {
  const modalTitle = taxPayer
    ? `Límites fijos para Contribuyente: ${taxPayer.socialName}`
    : `Límites fijos para Contribuyente`;

  const onClose = () => {
    onCancel();
  };

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <TaxPayerFixedLimitsForm
              taxPayer={taxPayer}
              onCancel={onCancel}
              onSuccess={onSuccess}
              clearOnSuccess={false}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default TaxPayerFixedLimitsModal;
